import React from 'react';
import {
  Calendar,
  dateFnsLocalizer
} from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { format, parse, startOfWeek, getDay } from 'date-fns';

const locales = {
  'en-US': require('date-fns/locale/en-US')
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales
});

// 🧾 Mock events from JSON
const liabilityEvents = [
  {
    title: '₱579,339.00',
    start: new Date('2025-07-21'), // Mon
    end: new Date('2025-07-21'),
    color: 'red'
  },
  {
    title: '₱2,579,339.00',
    start: new Date('2025-07-22'), // Tue
    end: new Date('2025-07-22'),
    color: 'red'
  },
  {
    title: '₱20,189,339.00',
    start: new Date('2025-07-23'), // Wed
    end: new Date('2025-07-23'),
    color: 'blue'
  },
  {
    title: '₱30,777,129.00',
    start: new Date('2025-07-24'), // Thu
    end: new Date('2025-07-24'),
    color: 'green'
  },
  {
    title: '₱28,777,129.00',
    start: new Date('2025-07-25'), // Fri
    end: new Date('2025-07-25'),
    color: 'orange'
  }
];


const eventStyleGetter = (event: any) => {
  const backgroundColor = event.color || '#3174ad';
  return {
    style: {
      backgroundColor,
      color: 'white',
      borderRadius: '5px',
      padding: '2px',
      border: 'none'
    }
  };
};

const LiabilityScheduleCalendar = () => {
  return (
    <div style={{ height: '100vh', padding: 20 }}>
      <Calendar
        localizer={localizer}
        events={liabilityEvents}
        startAccessor="start"
        endAccessor="end"
        defaultView="month"
        views={['month']}
        style={{ height: '100%' }}
        eventPropGetter={eventStyleGetter}
      />
    </div>
  );
};

export default LiabilityScheduleCalendar;
